import React from 'react';
import { useWebSocket } from '../context/WebSocketContext';
import { FiWifi, FiWifiOff } from 'react-icons/fi';

const RealtimeBadge = () => {
    const { connected } = useWebSocket();

    return (
        <span className={`realtime-badge ${connected ? 'connected' : 'disconnected'}`}>
            {connected ? (
                <><FiWifi /> <span>LIVE</span></>
            ) : (
                <><FiWifiOff /> <span>Offline</span></>
            )}
        </span>
    );
};

export default RealtimeBadge;
